/**
 * 模組名稱：NotifyPermissionUpdate
 * 模組說明：角色權限修改提示重新登入頁面
 * @module NotifyPermissionUpdate
 */

// ----- import from npm modules -----
import SweetAlert from 'sweetalert2';

// ----- import from local modules -----
import { React, BaseComponent } from '../../components/BaseComponent';
import Error404 from '../error-404/Error404';

export default class NotifyPasswordUpdate extends BaseComponent {
    constructor(props) {
        super(props);
        this.onConfirm = this.onConfirm.bind(this);
        this.state = {
            show: true,
        };
    }

    onConfirm() {
        this.setState({
            show: false,
        }, () => {
            window.location = this.getUrl('/');
        });
    }

    render() {
        if (this.state.show) {
            SweetAlert.fire({
                icon: 'warning', // modal種類
                title: '使用者角色權限已被修改', // 標題
                text: '請重新登入或洽系統管理員', // 內文
                showCancelButton: false, // 是否顯示取消按鈕
                confirmButtonText: '回首頁', // 確定按鈕文字
                showCloseButton: false, // 是否於modal右上方顯示"x"關閉按鈕
                //allowEnterKey: false, // 是否允許非focus於按鈕時，按下Enter或Space bar觸發confirm
                allowOutsideClick: false, // 是否允許點擊modal外的區域觸發dismiss
                allowEscapeKey: false, // 是否允許按下Esc來觸發dismiss
                // 自訂className以符合Bootstrap樣式
                customClass: {
                    confirmButton: 'btn btn-primary m-2', // 確定按鈕
                    content: 'font-weight-normal', // 內文
                },
                buttonsStyling: false, // 是否使用SweetAlert預設的ButtonsStyle，false才可正確套用customStyle
               timer: null, // 多少時間後消失 預設為null不消失 單位為milliseconds
            }).then((result) => {
                if (result.value) {
                    // handle confirm
                    this.onConfirm();
                } else if (result.dismiss) {
                    // handle dismiss
                    // this.onCancel();
                }
            });
        }
        return (
            <Error404 />
        );
    }
}
